import React, { useEffect, useState } from 'react'
import { LegalModal } from '@srca-b2b/kp5-ui-common/lib'
import { useAuth } from '@srca-b2b/kp5-ui-common/context/AuthContext'
import { getAllUnacceptedLegals } from '@srca-b2b/kp5-ui-common/utils/legalAPIs'
import { useRouter } from 'next/router'

const VERIFIED_AGREEMENTS = 'verifiedAgreements'

const ModalGlobalAgreement = () => {
  const { pathname } = useRouter()
  const loggedInUser = useAuth()
  const [show, setShow] = useState(false)
  const [agreements, setAgreements] = useState([])

  useEffect(() => {
    const getData = async () => {
      const response = await getAllUnacceptedLegals()
      if (response?.data) {
        if (response.data.length) {
          setAgreements(response.data)
          setShow(true)
        } else {
          sessionStorage.setItem(VERIFIED_AGREEMENTS, '200')
        }
      }
    }

    if (loggedInUser && pathname != '/register') {
      const verifiedAgreements = sessionStorage.getItem(VERIFIED_AGREEMENTS)
      if (!verifiedAgreements) getData()
    }
  }, [])

  if (!loggedInUser || pathname == '/register' || agreements.length < 1) return null
  return <LegalModal agreements={agreements} show={show} setShow={setShow} global />
}

export default ModalGlobalAgreement
